import {
  FormControl,
  FormHelperText,
  InputLabel,
  makeStyles,
} from '@material-ui/core'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import DeleteIcon from '@material-ui/icons/Delete'
import { useField } from 'formik'

import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'

const useStyles = makeStyles(theme => ({
  root: ({ width }) => ({
    width,
  }),
  deleteIcon: {
    color: 'white',
  },
  deleteImage: {
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'none',
    justifyContent: 'center',
    height: '100%',
    position: 'relative',
    width: '100%',
  },
  image: {
    alignItems: 'center',
    backgroundColor: 'white',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    border: '1px solid transparent',
    borderRadius: theme.shape.borderRadius,
    borderColor: theme.palette.fadedPurple.main,
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    '&:hover': {
      cursor: 'pointer',
      borderColor: theme.palette.lightPurple.main,
    },
    '&:hover .delete': {
      display: 'flex',
    },
    width: '100%',
  },
  label: ({ height, width }) => ({
    display: 'block',
    borderRadius: theme.shape.borderRadius,
    height,
    overflow: 'hidden',
    width,
  }),
  selectImage: {
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
    },
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    position: 'relative',
    width: '100%',
  },
  input: {
    display: 'none',
  },
}))

const FormikImageFileField = ({
  className,
  height,
  label,
  margin,
  name,
  variant,
  width,
}) => {
  const [field, meta] = useField({ name })
  const { touched, error } = meta
  const hasError = Boolean(touched && error)
  const { onChange, value } = field

  const classes = useStyles({ height, width })
  const [filePreview, setFilePreview] = useState()
  const fileInput = useRef()

  const isFile = value instanceof File
  const mediaPreview = !isFile && value

  const handleChange = value => onChange({ target: { name, value } })
  const handleChangeFile = event => {
    handleChange(event.currentTarget.files[0])
  }
  const handleClickDelete = event => {
    event.preventDefault()
    fileInput.current.value = ''
    handleChange('')
  }
  const handleClickDeleteArea = event => {
    event.preventDefault()
  }

  useEffect(() => {
    if (isFile) {
      setFilePreview(URL.createObjectURL(value))
    } else {
      setFilePreview(null)
    }
  }, [value])

  return (
    <FormControl
      error={hasError}
      margin={margin}
      variant={variant}
      className={clsx(classes.root, className)}
    >
      {!value && <InputLabel shrink>{label}</InputLabel>}
      <label className={classes.label}>
        <div
          style={{
            backgroundImage: mediaPreview
              ? `url(${mediaPreview})`
              : filePreview
              ? `url(${filePreview})`
              : `none`,
          }}
          className={classes.image}
        >
          {!value ? (
            <div className={clsx(classes.selectImage)}>
              <AddCircleIcon className={classes.addIcon} />
            </div>
          ) : (
            <div
              className={clsx('delete', classes.deleteImage)}
              onClick={handleClickDeleteArea}
            >
              <DeleteIcon
                className={classes.deleteIcon}
                onClick={handleClickDelete}
              />
            </div>
          )}
        </div>
        <input
          className={classes.input}
          accept="image/*"
          onChange={handleChangeFile}
          ref={fileInput}
          type="file"
        />
      </label>
      {hasError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  )
}

FormikImageFileField.defaultProps = {
  height: 125,
  variant: 'filled',
  width: 125,
}

export default FormikImageFileField
